import { IMG_TYPES, SUPPORTED_LOCALES } from '@repo/config';
import { z } from 'zod';

export const enqueueImgJobItemSchema = z.object({
  type: z.enum(IMG_TYPES),
  slug: z.string().min(1),
  locale: z.enum(SUPPORTED_LOCALES),
});

export const enqueueImgJobsRequestSchema = z.object({
  items: z.array(enqueueImgJobItemSchema).min(1),
});

export type IEnqueueImgJobItem = z.infer<typeof enqueueImgJobItemSchema>;
export type IEnqueueImgJobsRequest = z.infer<typeof enqueueImgJobsRequestSchema>;
